<template>
  <LayoutGame>
    <div class="main">
      <Home />
      <Instructions />
      <!-- <Game /> -->
      <!-- <GameOver /> -->
      <Settings />
    </div>
  </LayoutGame>
</template>

<script>
import { mapGetters } from 'vuex';
// import { Howl } from 'howler';
// import lottie from 'lottie-web/build/player/lottie';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'ClownToWater',
  components: {
    Home: () => import('@/components/practices/clown_to_water/Home.vue'),
    Instructions: () => import('@/components/practices/clown_to_water/Instructions.vue'),
    // Game: () => import('@/components/practices/clown_to_water/Game.vue'),
    // GameOver: () => import('@/components/practices/clown_to_water/GameOver.vue'),
    LayoutGame: () => import('@/layouts/LayoutGame.vue'),
    Settings: () => import('@/components/practices/Settings.vue'),
  },
  computed: {
    ...mapGetters({
      // currentExercise: 'clownToWater/currentExercise',
      // currentLives: 'clownToWater/currentLives',
      // exerciseCompleted: 'clownToWater/exerciseCompleted',
      // homeScreenStatus: 'clownToWater/homeScreenStatus',
      muteStatus: 'settings/muteStatus',
    }),
  },
  watch: {
    muteStatus: state => {
      if (state) {
        sounds.mute(true);
      } else {
        sounds.mute(false);
      }
    },
  },
  mounted() {
    sounds.clownToWaterBackground.play();
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.main {
  @include container;
  background-image: url(~@/assets/practices/clown_to_water/background.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: $clown-to-water-color-text-main;
  font-size: 5vh;
  font-family: 'Young', sans-serif;
  height: 100vh;
}
</style>
